import { render, staticRenderFns } from "./MaterialLoteCard.vue?vue&type=template&id=90e84444"
import script from "./MaterialLoteCard.vue?vue&type=script&lang=js"
export * from "./MaterialLoteCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialLoteCard.vue?vue&type=style&index=0&id=90e84444&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports